export default "__VITE_ASSET__$Qzwiveo__"